<template>
  <v-sheet style='position:sticky;top:5rem;'>
    <v-carousel
      cycle
      hide-delimiters
      show-arrows="hover"
      height="250"
    >
      <v-carousel-item
        :src="require('/src/assets/hot-linux-logos.png')"
      >
      </v-carousel-item>
      <v-carousel-item
        :src="require('/src/assets/運用を考えた提案.png')"
      >
      </v-carousel-item>
      <v-carousel-item
        :src="require('/src/assets/laptop-gf2202becc_1920.webp')"
      >
      </v-carousel-item>

      <v-carousel-item
        :src="require('/src/assets/効率化.png')"
      >
      </v-carousel-item>
      <v-carousel-item
        :src="require('/src/assets/keyboard-gc31320c14_1920.webp')"
      >
      </v-carousel-item>
      
      <v-carousel-item
        :src="require('/src/assets/使いやすいシステム.png')"
      >
      </v-carousel-item>

      <v-carousel-item
        :src="require('/src/assets/remote_work.jpg')"
      >
      </v-carousel-item>
      <v-carousel-item
        :src="require('/src/assets/system1.webp')"
      >
      </v-carousel-item>
    </v-carousel>
    <v-expansion-panels class='mt-2' v-model='expand' dense>
      <v-expansion-panel>
        <v-expansion-panel-title>Hot Linux ／ ホットリナックス について</v-expansion-panel-title>
          <v-expansion-panel-text class='text-body-2'>
            <span v-html='サイト概要'></span>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
    <coconara-link
      class='d-block smallScreen'
    ></coconara-link>
    <v-expansion-panels class='mt-2' v-model='expand2' dense>
      <v-expansion-panel>
      <v-expansion-panel-title>
        Hot Linux ／ SNS
      </v-expansion-panel-title>
      <v-expansion-panel-text>
        <v-list>
          <v-list-item
            href="https://www.facebook.com/hotlinux"
            target="_blank"
          >
            <template v-slot:prepend>
              <v-avatar rounded="0">
                <v-img :src="require('/src/assets/Facebook_Logo_Primary.png')"></v-img>
              </v-avatar>
            </template>
            Facebook
          </v-list-item>
          <v-list-item
            href="https://twitter.com/masashi012"
            target="_blank"
          >
            <template v-slot:prepend>
              <v-avatar rounded="0">
                <v-img :src="require('/src/assets/logo-black.png')"></v-img>
              </v-avatar>
            </template>
            X(Twitter)
          </v-list-item>
          <v-list-item
            href="https://www.threads.net/@masashi012"
            target="_blank"
          >
            <template v-slot:prepend>
              <v-avatar rounded="0">
                <v-img :src="require('/src/assets/threads-logo-black.svg')"></v-img>
              </v-avatar>
            </template>
            Threads
          </v-list-item>
          <v-list-item
            href="https://www.linkedin.com/in/masashi012"
            target="_blank"
          >
            <template v-slot:prepend>
              <v-avatar rounded="0">
                <v-img :src="require('/src/assets/In-Blue-Logo.png.original.png')"></v-img>
              </v-avatar>
            </template>
            LinkedIn
          </v-list-item>
          <v-list-item
            href="https://www.instagram.com/masashi012/"
            target="_blank"
          >
            <template v-slot:prepend>
              <v-avatar rounded="0">
                <v-img :src="require('/src/assets/Instagram_Glyph_Gradient.png')"></v-img>
              </v-avatar>
            </template>
            Instagram
          </v-list-item>
        </v-list>
      </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-sheet>
</template>

<script>
import CoconaraLink from './CoconaraLink.vue'
export default {
  components: { CoconaraLink },
  data(){
    return {
      サイト概要:"",
      expand:[0],
      expand2:[],
    }
  },

  mounted(){
    this.サイト情報取得()
    setTimeout(() => {
      this.expand = []
    },1000)

  },

  methods:{
    サイト情報取得(){
      this.$emit('overlay');
      let url = './api/api.php';
      let data = {
        func:"サイト情報取得",
        pageSize:10,
      };

      let param = {
          method : "POST",
          headers : { "Content-Type": "application/json" },
          body : JSON.stringify(data),
          }
      fetch(url,param)
      .then(response => {return response.text();})
      .then(result => {
        try {
          const jsonData = JSON.parse(result);
          return jsonData;
        }catch(e){
          return Promise.reject({body:result,type:'unparsable'})
        }
      })
      .then(result => {
        this.サイト概要 = result.サイト情報row.サイト概要;
        this.$emit('overlay');
      })
      .catch(error =>{
        console.log(error)
        alert('取得できませんでした。\n\n'+error.body);
        this.$emit('overlay');
      })
    },
  }

}
</script>